import {
  CalendarClockIcon,
  CircleCheckIcon,
  MissionIcon,
  TrendingUpIcon,
} from 'assets/icons';
import ResultTiles from 'components/stats/ResultTiles';
import { wholeEuros } from 'pages/companies/recordItems';
import useText from 'hooks/useText';
import { RecordSection } from './RecordLayout';

/**
 * « Résultats » of the work with a company over the last 12 months
 * (admin/crm/company/results): the appointments held and not held, the
 * missions it asked for and the revenue invoiced excluding VAT, for every CRM
 * role (decision 34). A null `invoicedRevenue` (older api) shows no revenue
 * tile, rather than a 0 that would read as no sales.
 */
const ResultsCard = ({ results }) => {
  const { text, plural } = useText('record');
  const count = (key, icon, value) => ({
    key,
    icon,
    value: String(value ?? 0),
    label: plural(key, value ?? 0),
  });
  const tiles = [
    count('resultsDone', CircleCheckIcon, results.appointmentsDone),
    count('resultsNotDone', CalendarClockIcon, results.appointmentsNotDone),
    count('resultsMissions', MissionIcon, results.missionsRequested),
    results.invoicedRevenue != null && {
      key: 'revenue',
      icon: TrendingUpIcon,
      value: wholeEuros(results.invoicedRevenue),
      label: text('resultsRevenue'),
    },
  ].filter(Boolean);
  return (
    <RecordSection
      title={text('results')}
      action={
        <span className="text-xs text-gray-400">{text('resultsPeriod')}</span>
      }
    >
      <ResultTiles tiles={tiles} layout="record" />
    </RecordSection>
  );
};

export default ResultsCard;
